import { render, staticRenderFns } from "./Dialog_ClassDetail.vue?vue&type=template&id=0c94f59a&scoped=true&"
import script from "./Dialog_ClassDetail.vue?vue&type=script&lang=js&"
export * from "./Dialog_ClassDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c94f59a",
  null
  
)

export default component.exports